const MenuItemsType = {
    LOAD: 'menu_items/load',
    CLICK: 'menu_items/click',
    GET: 'menu_items/get',
  };
  
  export default MenuItemsType;
  